<template>
  <button
    :class="classList"
    :disabled="!active"
    unselectable="on"
    @click="clicked($event)">
    <slot>Submit</slot>

    <sprite v-if="icon" :name="icon"></sprite>
  </button>
</template>

<script>
  /**
   * Button - A wrapper around the much loved button tag
   *
   * Adds active state and types of button
   */
  import Sprite from '../Sprite.vue'

  export default {
    name: 'Button',

    components: {
      Sprite
    },

    props: {
      active: {
        type: Boolean,
        default: true
      },

      type: {
        type: String,
        default: ''
      },

      icon: {
        type: String
      }
    },

    methods: {
      clicked(e) {
        this.$emit('click', e)
      }
    },

    computed: {
      classList() {
        let classes = ['btn']

        if(this.type) {
          classes.push(`is-${this.type}`)
        }

        return classes.join(' ')
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'
  // @import '../../../styles/helpers/theming'

  .btn
    // @include themify($themes)
    //   width: themed('button-width')
    //   min-width: themed('button-min-width')

    display: flex
    justify-content: center
    align-items: center
    border: 0
    opacity: 1
    transition: opacity $transition-duration ease-in-out
    cursor: pointer
    padding: 0px $pad
    height: 30px
    border-radius: 3px
    border: 2px solid
    background: none
    margin-top: 20px
    font-family: $app-font-slab
    font-weight: $font-light
    font-size: 11px
    line-height: 1
    transition: background-color $transition-duration $transition-easing, border $transition-duration $transition-easing
    user-select: none
    outline: none
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0)
    -webkit-tap-highlight-color: transparent

    color: $color-primary
    border-color: $color-primary
    text-transform: uppercase

    &:disabled
      cursor: default
      border-color: rgba($color-primary, 0.3)
      color: rgba($color-primary, 0.3)

      .sprite
        fill: rgba($color-primary, 0.3)

    // Major button
    &.is-primary
      border: none
      background-color: $color-primary
      color: $color-button-text

      .sprite
        fill: $color-button-text

      &:disabled
        background: rgba($color-primary, 0.3)

    &.is-secondary
      border-radius: 0
      text-transform: none
      background-color: none
      border: 1px solid rgba(0, 0, 0, 0.15)
      color: $color-text
      font-weight: 400

      .sprite
        fill: $color-text

      &:disabled
        color: rgba($color-text, 0.3)

    &.is-danger
      border: none
      background-color: $color-error
      color: $color-button-text

      &:disabled
        background: rgba($color-error, 0.3)

      .sprite
        fill: $color-button-text

    .sprite
      width: 16px
      height: 16px
      margin-left: 5px
      fill: $color-primary

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/Button.vue